import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from './store/store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </ReduxProvider>
);

// PWA Install Handler
let deferredPrompt: any = null;

console.log('🚀 PWA System Starting...');
console.log('📱 User Agent:', window.navigator.userAgent);
console.log('🔒 Protocol:', window.location.protocol);

window.addEventListener('beforeinstallprompt', (e: Event) => {
  e.preventDefault();
  deferredPrompt = e;
  (window as any).__deferredPrompt = e;
  console.log('✅ beforeinstallprompt event fired!');
  window.dispatchEvent(new CustomEvent('pwa-deferred', { detail: true }));
});

window.addEventListener('appinstalled', () => {
  console.log('✅ App installed successfully!');
  deferredPrompt = null;
  (window as any).__deferredPrompt = null;
});

// Check manifest
setTimeout(() => {
  const manifest = document.querySelector('link[rel="manifest"]');
  console.log('📋 Manifest link:', manifest ? 'Found' : 'NOT FOUND');
}, 100);

// Register service worker
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('🔄 Service worker update available');
    window.dispatchEvent(new CustomEvent('swUpdated', { detail: { registration } }));
  },
  onSuccess: (registration) => {
    console.log('✅ Service worker registered successfully');
    window.dispatchEvent(new CustomEvent('swRegistered', { detail: { registration } }));
  },
});

reportWebVitals();
